<template>
  <div style="position: absolute;  top: 30px;  right: 20%;display: flex;align-items: center;">
    <div style="display: inline-block;  width: 30px;  height: 20px;background: #ff9f43;" />
    <span class="ml-1 mr-1">Update the review</span>
    <div style="display: inline-block;  width: 30px;  height: 20px;background: #28c76f;" />
    <span class="ml-1 mr-1">Add the review</span>
    <div style="display: inline-block;  width: 30px;  height: 20px;background: #ea5455;" />
    <span class="ml-1 mr-1">Del the review</span>
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
}

</script>

<style lang='scss' scoped>

</style>
